module.exports = __webpack_public_path__ + "73ccb97fd8df0703038a40b00dc8ae5f.woff2";